'use client';

import type { ReactNode } from 'react';
import { cx } from '@/styled-system/css';
import type { OtpSignInGateState } from '@/src/lib/hooks/auth';
import { OtpSignInForm } from './OtpSignInForm';
import { gatedContent } from './otpSignIn.styles';

export type OtpSignInGateProps = {
  gate: OtpSignInGateState;
  /** Heading for the code step. Omit when the host renders its own title. */
  title?: string;
  /** Applied to both the form wrapper and the code-step wrapper, so the swap keeps its layout. */
  className?: string;
  children: ReactNode;
};

/**
 * Shows the email-code step in place of `children` while `gate.requireSignIn` waits on it.
 * The children are hidden, not unmounted, so everything the renter typed is still there when
 * they go back or when the gated action runs.
 */
export function OtpSignInGate({ gate, title, className, children }: OtpSignInGateProps) {
  const { codeStep } = gate;

  return (
    <>
      <div className={cx(gatedContent, className)} hidden={codeStep !== null}>
        {children}
      </div>
      {codeStep && (
        <div className={className}>
          <OtpSignInForm
            email={codeStep.email}
            sendLimitReached={codeStep.sendLimitReached}
            title={title}
            onVerified={() => void gate.handleVerified()}
            onBack={gate.handleBack}
          />
        </div>
      )}
    </>
  );
}
